import React, { useState, useEffect } from "react";
import settingsIcon from "../../assets/images/icons/settingsIcon.svg";
import { Link } from "react-router-dom";
// import ListAllMembers from "../../pages/messaging_system/modals/ListAllMembers";
// import CreateGroupChat from "../../pages/messaging_system/modals/CreateGroupChat";

import ProtectedComponent from '../../permissions/ProtectedComponent';
import { permissions } from '../../permissions/roles';
import PermissionWrapper from "../../permission_advance/PermissionWrapper";
function UserDetailHeader({
  actionButtons,
  addNewDocument,
  addNewIncident,
  typeSelectBox,
  addNewTraining,
  createNewForm,
  consentCapacitySelectBox,
  addNewAppointment,
  addNewMessage,
  serviceUsers,
  shiftLocation,
  backToReports,
}) {
  const [isNewMsgSelectStaff, setIsNewMsgSelectStaff] = useState(false);
  const [isCreateGroupModal, setIsCreateGroupModal] = useState(false);

  const handleSelectStaffForMessage = () => {
    setIsNewMsgSelectStaff(true);
  };

  const handleCreateGroupModal = () => {
    setIsCreateGroupModal(true);
  };

  const handleCloseAddNewMsgModel = () => {
    setIsNewMsgSelectStaff(false);
  };

  const handleCloseCreateGroupModal = () => {
    setIsCreateGroupModal(false);
  };

  if (
    actionButtons ||
    addNewDocument ||
    addNewIncident ||
    typeSelectBox ||
    addNewTraining ||
    createNewForm ||
    consentCapacitySelectBox ||
    addNewAppointment ||
    addNewMessage ||
    serviceUsers ||
    backToReports
  ) {
    return (
      <>
        <header className="headerContainerSearchAction">
          <div className="actionButtons">
            {backToReports ? (
              <div className="gap-1">
                <Link
                  className="btn btn-sm btn-primary"
                  to="/reports"
                >
                  Back to Reports
                </Link>

              </div>
            ) : null}
            {addNewMessage ? (
              <div className="gap-1">
                <Link
                  className="btn btn-sm btn-primary"
                  onClick={handleSelectStaffForMessage}
                >
                  New Chat
                </Link>

                <Link
                  className="btn btn-sm btn-primary"
                  onClick={handleCreateGroupModal}
                >
                  Create Group
                </Link>

              </div>
            ) : null}
            {addNewTraining ? (
              <>

                <Link to="/add-training-quizzes" className="btn btn-sm btn-primary">
                  Add New Quizzes
                </Link>



                <Link to="/add-training" className="btn btn-sm btn-primary">
                  Add New Training
                </Link>

              </>
            ) : null}
            {serviceUsers ? (
              <>
                <PermissionWrapper title="Service User" action="create">
                  <Link to="/add-service-user" className="btn btn-sm btn-primary">
                    Add New Service User
                  </Link>
                </PermissionWrapper>
                {/* 
                  <Link to="/add-service-user" className="btn btn-sm btn-primary">
                    Add New Service User
                  </Link>
                 */}
                <PermissionWrapper title="Enquiries" action="create">
                  <Link
                    to="/service-user-enquiries"
                    className="btn btn-sm btn-primary"
                  >
                    Add New Enquiries
                  </Link>
                </PermissionWrapper>
              </>
            ) : null}
            {addNewIncident ? (
              <>

                <Link to="/add-incidents" className="btn btn-sm btn-primary">
                  Add New Incident
                </Link>

              </>
            ) : null}
            {createNewForm ? (
              <>

                <Link
                  to="/add-consent-capacity"
                  className="btn btn-sm btn-primary"
                >
                  Creat New Form
                </Link>

              </>
            ) : null}
            {addNewAppointment ? (
              <>
                <PermissionWrapper title="Appointments" action="create">
                  <Link
                    to="#"
                    className="btn btn-sm btn-primary"
                  >
                    Add New Appointment
                  </Link>
                </PermissionWrapper>
              </>
            ) : null}
            {addNewDocument ? (
              <>

                <button className="btn btn-sm btn-primary">
                  Add New Document
                </button>

              </>
            ) : null}
            {actionButtons ? (
              <>
                <button className="btn btn-sm btn-outline-primary">
                  Export Sheet
                </button>
                <PermissionWrapper title="Payroll" action="view">
                  <button className="btn btn-sm btn-primary">
                    Finalize Payroll
                  </button>
                </PermissionWrapper>
                <button className="btn btn-sm btn-outline-primary img-btn">
                  <img src={settingsIcon} alt="Settings" />
                </button>
              </>
            ) : null}
          </div>
        </header>
        {/*  {isNewMsgSelectStaff && (
          <ListAllMembers
            handleShowModel={isNewMsgSelectStaff}
            onClose={handleCloseAddNewMsgModel}
          />
        )} */ }
        {/*  {isCreateGroupModal && (
          <CreateGroupChat
            handleShowModel={isCreateGroupModal}
            handleCloseModel={handleCloseCreateGroupModal}
          />
        )} */ }
      </>
    );
  }
}

export default UserDetailHeader;
